import { useSearchParams } from 'react-router';

import { useEngagementRecords, useWaiverRecords } from '@/apps/engagement-letter-database/store';

import DashboardDataGrid from './components/DashboardDataGrid';
import HeaderPane, { type LetterType } from './components/HeaderPane';

function HomeDashboard() {
  const [searchParams, setSearchParams] = useSearchParams();
  const letterType = (searchParams.get('letterType') as LetterType) || 'engagement';

  useEngagementRecords();
  useWaiverRecords({ enabled: letterType === 'waiver' });

  const handleLetterTypeChange = (value: LetterType) => {
    setSearchParams((prev) => {
      if (value === 'engagement') {
        prev.delete('letterType');
      } else {
        prev.set('letterType', value);
      }
      return prev;
    });
  };

  return (
    <>
      <HeaderPane letterType={letterType} onLetterTypeChange={handleLetterTypeChange} />
      <DashboardDataGrid letterType={letterType} />
    </>
  );
}

export default HomeDashboard;
